<template>
    <div class="wrapper-bg">
        <div class="pdpa-inproject">
            <div class="header-container">
                <div class="header-inner">
                    <div class="img-back" @click="gotopage('/profile')">
                        <img src="../../../assets/icon/angle-small-left.svg" />
                    </div>
                    <div class="header-wrapper">
                        <img
                            v-if="$route.name === 'termstheme'"
                            src="../../../assets/pdpa/terms.svg"
                            alt="img-head"
                        />
                        <img
                            v-if="$route.name !== 'termstheme'"
                            src="../../../assets/pdpa/privacy.svg"
                            alt="img-head"
                        />
                    </div>
                </div>
            </div>

            <div class="content-main">
                <div class="desc-container" v-if="$route.name === 'termstheme'">
                    <Term />
                </div>
                <div class="desc-container" v-else>
                    <Privacy />
                </div>
            </div>
            <a class="goToTop" @click="goToTop">
                <svg
                    height="512px"
                    id="Layer_1"
                    style="enable-background: new 0 0 512 512"
                    version="1.1"
                    viewBox="0 0 512 512"
                    width="512px"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                    <path
                        d="M256,213.7L256,213.7L256,213.7l174.2,167.2c4.3,4.2,11.4,4.1,15.8-0.2l30.6-29.9c4.4-4.3,4.5-11.3,0.2-15.5L264.1,131.1  c-2.2-2.2-5.2-3.2-8.1-3c-3-0.1-5.9,0.9-8.1,3L35.2,335.3c-4.3,4.2-4.2,11.2,0.2,15.5L66,380.7c4.4,4.3,11.5,4.4,15.8,0.2L256,213.7  z"
                        fill="#544437"
                    />
                </svg>
            </a>
        </div>
    </div>
</template>
<script>
//component
import Term from "@/module/Pdpapage/component/TermDetail.vue";
import Privacy from "@/module/Pdpapage/component/PrivacyDetail.vue";

export default {
    name: "Pdpa",
    components: {
        Term,
        Privacy,
    },
    data: function () {
        return {
            isLoaded: true,
            activeTab: "TermCondition",
        };
    },
    created: function () {},
    mounted: function () {},
    methods: {
        switchTab: function (tabName) {
            this.activeTab = tabName;
        },
        gotopage(path) {
            this.$router.push(path);
        },
        goToTop() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/_mixin.scss";
$primary-color: #65513e;
$secondary-color: salmon;
$bg-color: #dfdcd9;
p {
    margin: 0;
}
.wrapper-bg {
    &:after {
        content: "";
        background: url(/img/footer_order.svg);
        width: 100%;
        height: 0;
        padding-bottom: 35%;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 0;
    }
}
.pdpa-inproject {
    padding-bottom: 1.25rem;
    position: relative;
    .goToTop {
        position: fixed;
        right: 15px;
        bottom: 15px;
        z-index: 5;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 50%;
        background-color: #eee2d9;
        svg {
            width: 20px;
            height: 20px;
            display: inline;
            vertical-align: middle;
            margin-top: -2px;
        }
    }
    .header-container {
        margin-left: 1.25rem;
        .header-inner {
            border-bottom-left-radius: 50px;
            margin-left: -1.25rem;
            .img-back {
                position: absolute;
                top: 20px;
                left: 10px;
                > img {
                    width: 25px;
                }
            }
            .header-wrapper {
                justify-content: center;
                display: flex;
                padding: 1.25rem;
                img {
                    margin-right: 5px;
                    height: 1.75rem;
                }
            }
        }
    }
    .content-main {
        padding: 1.25rem;
        color: $color-text;
    }
    .btn-submit-wrapper {
        margin: 1.25rem;
        width: calc(100% - 2.5rem);
        .btn-submit {
            text-align: center;
            color: #fff;
            background: $primary-color;
            padding: 0;
            border-radius: 5px;
            font-size: 22px;
            height: 45px;
            line-height: 45px;
            // &.disabled {
            //     // opacity: 0.3;
            //     background: #d8d8d8;
            //     pointer-events: none;
            // }
        }
    }
}
</style>
